import React, { useState, useMemo } from "react";
import { Spin } from "antd";
import { useSelector } from "react-redux";
import { baseURL } from "../../globalUtils/axiosConfig";

const BackgroundJobs = () => {
  const [loading, setLoading] = useState(true);

  const tenantName = useSelector((state) => state.authReducer.user?.tenant);

  const dashboardUrl = useMemo(() => {
    return tenantName ? `${baseURL}/admin/queues/${tenantName}` : "";
  }, [tenantName]);

  const handleLoad = () => {
    setLoading(false);
  };

  return (
    <div style={{ position: "relative", width: "100%", height: "100vh" }}>
      {loading && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "rgba(255, 255, 255, 0.8)",
            zIndex: 10,
          }}
        >
          <Spin size='medium' />
        </div>
      )}

      <iframe
        src={dashboardUrl}
        width='100%'
        height='100%'
        onLoad={handleLoad}
        title={`Background Jobs - ${tenantName}`}
        allowFullScreen
        style={{
          border: "none",
          display: "block",
          height: "100vh",
          width: "100%",
        }}
      ></iframe>
    </div>
  );
};

export default BackgroundJobs;
